// Dependencies
import React from 'react';
import Modal from 'react-modal';

// Assets
import './MessageModal.css';


const MessageModal = ({ isOpen, message, onRequestClose }) => (
  <div className="MessageModal">
    <Modal
      className="MessageModalContent d-flex flex-column justify-content-center align-items-center"
      overlayClassName="MessageModalOverlay"
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick={false}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          {/* <div className="modal-header"/> */}
          <div className="modal-body">
            <span>{message}</span>
          </div>
          <div className="modal-footer justify-content-center">
            <button className="btn btn-secondary"
              onClick={onRequestClose}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </Modal>
  </div>
);

export default MessageModal;
